import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { AnimationsModule } from '../animations/animations.module';
import { ColorModule } from '../color/color.module';

import { AccordionHeaderComponent, AccordionContentComponent, AccordionComponent, AccordionGroupComponent } from './accordion.component';
import { AccordionToggleDirective } from './accordion.directive';
export class AccordionModule {static decorators: DecoratorInvocation[] = [
{ type: NgModule, args: [{
    imports: [CommonModule, AnimationsModule, ColorModule],
    exports: [AccordionHeaderComponent, AccordionContentComponent, AccordionComponent, AccordionGroupComponent],
    declarations: [AccordionToggleDirective, AccordionHeaderComponent, AccordionContentComponent, AccordionComponent, AccordionGroupComponent]
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

function AccordionModule_tsickle_Closure_declarations() {
/** @type {?} */
AccordionModule.decorators;
/**
 * @nocollapse
 * @type {?}
 */
AccordionModule.ctorParameters;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
